import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch } from 'react-router-dom'
import indexRoutes from "routes/index.jsx";
import { history } from './helper/history';
import store from "./redux/store/index";
import { Provider } from "react-redux";
import bugsnagClient from './lib/bugsnag'

if (process.env.NODE_ENV === 'development') {
    ReactDOM.render(
        <Provider store={store}>
            <Router history={history} >
                <Switch>
                    {indexRoutes.map((prop, key) => {
                        return <Route exact={prop.exactPro} path={prop.path} component={prop.component} key={key} />;
                    })}
                </Switch>
            </Router>
        </Provider>
        ,
        document.getElementById("root")
    );
}

else {
    var ErrorBoundary = bugsnagClient.getPlugin('react')
    ReactDOM.render(
        <ErrorBoundary >
            <Provider store={store}>
                    <Router history={history} >
                        <Switch>
                            {indexRoutes.map((prop, key) => {
                                return <Route exact={prop.exactPro} path={prop.path} component={prop.component} key={key} />;
                            })}
                        </Switch>
                    </Router>
            </Provider>
        </ErrorBoundary>
        ,
        document.getElementById("root")
    );
}



// WEBPACK FOOTER //
// ./src/index.js